// PRC EDITED: (PRC) Thumbnails on the left — keep the active thumbnail in view in the vertical column.
// Dawn's media-gallery.js only scrolls the thumbnail list horizontally.
(function () {
  const desktop = window.matchMedia('(min-width: 990px)');

  function watch(gallery) {
    const list = gallery.querySelector('.thumbnail-list');
    if (!list) return;

    const reveal = () => {
      if (!desktop.matches) return;
      const current = list.querySelector('[aria-current="true"]');
      const item = current && current.closest('.thumbnail-list__item');
      if (!item) return;
      const top = item.offsetTop;
      const bottom = top + item.offsetHeight;
      if (top < list.scrollTop) {
        list.scrollTo({ top, behavior: 'smooth' });
      } else if (bottom > list.scrollTop + list.clientHeight) {
        list.scrollTo({ top: bottom - list.clientHeight, behavior: 'smooth' });
      }
    };

    new MutationObserver(reveal).observe(list, { subtree: true, attributeFilter: ['aria-current'] });
  }

  document.querySelectorAll('media-gallery.prc-thumbs-left').forEach(watch);
})();
